<template>
    <div
        ref="app"
        id="cz2"
        :class="{
            'cz2__is-kiosk': isKiosk,
            'cz2--no-outlines': hideOutlines,
            'cz2--loaded': loaded,
            'cz2--scroll-overflow': isCheckoutStep && !isKiosk,
            'cz2__is-splash': isSplashPage,
            'cz2__is-sb': isSpellingBee,
            'cz2__is-mariners': isMariners,
            'cz2__is-emea': isEmea,
            'cz2__is-name-step': isNameStep,
            'cz2__is-review-step': isReviewStep,
            'cz2__is-contact-step': isContactStep,
            'cz2__is-confirm-step': isConfirmStep,
            'cz2__is-checkout-step': isCheckoutStep,
            'bg-darker-blue-gradient': showDarkerBackground,
        }"
        class="cz2"
        @keydown="keyDown"
        @mousedown="mouseDown"
        @scroll="onScroll"
        :style="targetStyles"
    >
        <div class="cz2__frame-lock">
            <div
                ref="frame"
                class="cz2__frame"
                :class="[
                    {
                        'cz2__frame--kiosk': isKiosk,
                    },
                ]"
            >
                <app-target @setStyles="setStyles" />

                <customizer />

                <kiosk-restart-button />

                <transition name="cz2__fade">
                    <kiosk-restart-warning v-if="kioskRestartShown" />
                </transition>

                <transition name="cz2__fade">
                    <change-warning v-if="changeWarningShown" />
                </transition>

                <transition name="cz2__fade">
                    <out-of-stock-warning v-if="outOfStockWarningShown" />
                </transition>

                <transition name="cz2__fade">
                    <protector-upsell-modal v-if="protectorUpsellShown" />
                </transition>

                <transition name="cz2__fade">
                    <discreet-packaging-modal v-if="discreetPackagingModalShown" />
                </transition>

                <transition name="cz2__fade">
                    <printing-progress v-if="printingShown" />
                </transition>

                <transition name="cz2__fade">
                    <printing-error v-if="printingErrorShown" />
                </transition>

                <transition name="cz2__fade">
                    <save-error v-if="saveErrorShown" />
                </transition>

                <transition name="cz2__fade">
                    <service-menu v-if="serviceMenuShown" />
                </transition>

                <inspect-modal v-if="!isSpellingBee && inspectModalShown" />
                <sb-inspect-modal v-if="isSpellingBee && inspectModalShown" />

                <transition name="cz2__fade">
                    <attach-pack-modal v-if="!isSpellingBee && attachPackModalShown" />
                    <sb-attach-pack-modal v-if="isSpellingBee && attachPackModalShown" />
                </transition>

                <transition name="cz2__fade">
                    <attach-pack-info-modal v-if="attachPackInfoModalShown" />
                </transition>

                <transition name="cz2__fade">
                    <pet-pack-info-modal v-if="petPackInfoModalShown" />
                </transition>

                <transition name="cz2__fade">
                    <product-info-modal v-if="productInfoModalShown" />
                </transition>

                <transition name="cz2__fade">
                    <switch-pop-modal v-if="switchPopModalShown" />
                </transition>

                <transition name="cz2__fade">
                    <switch-pop-modal v-if="switchPopModalShown" />
                </transition>

                <base-modal v-if="aiModalShown" />

                <preview-modal v-if="aiPreviewModalShown" />

                <transition name="cz2__fade">
                    <special-box-modal v-if="specialBoxModalShown" />
                </transition>

                <name-pop-modal v-if="namePopModalShown" />

                <transition name="cz2__fade">
                    <exit-modal v-if="exitModalShown" />
                </transition>

                <transition name="cz2__fade">
                    <mouse-leave-modal v-if="mouseLeaveModalShown" />
                </transition>

                <paper-status />

                <blur-modal
                    :is-open="isNavMenuOpen"
                    :swiperize="isKiosk"
                    ariaLabel="Main navigation"
                    @closed="closeNavMenu()"
                >
                    <transition name="cz2__fade-down">
                        <main-navigation-list
                            v-if="isNavMenuOpen"
                            @close="closeNavMenu()"
                        />
                    </transition>
                </blur-modal>

                <rotate-screen-message v-if="isMobile && isMobileDevice && !isKeyboardOpen" />

                <div v-if="globalBusy" class="cz2__global-busy">
                    <div
                        class="cz2__modal-popup"
                        :class="{ 'is-kiosk': isKiosk }"
                    >
                        <div class="cz2__modal-popup__body">
                            <focus-lock>
                                <div class="cz2__modal-popup__content" tabindex="0">
                                    <h1 class="cz2__type__huge-header cz2__text--center cz2__no-margin">
                                        {{ $t('JUST_A_MOMENT') }}
                                    </h1>
                                </div>
                            </focus-lock>
                        </div>
                    </div>
                </div>

                <transition name="cz2__fade">
                    <funko-spinner v-if="aiSpinnerShown" />
                </transition>

                <transition name="cz2__fade">
                    <timeout-warning v-if="timeoutShown" />
                </transition>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "style/variables.scss";

    // Prevent pull to refresh on mobile
    html, body {
        overscroll-behavior: none;
        scroll-behavior: smooth;
    }

    // Override Funko header & footer styles
    #site-header,
    #footercontent {
        display: none !important;
    }
    div.page {
        margin-top: 0 !important; // Apply top margin that matches their header height
    }
    // @media (min-width: 544px) {
    //     div.page {
    //         margin-top: 38px;
    //     }
    // }

    // Global.
    .cz2__overlay-lock {
        // overflow: hidden;
    }

    #cz2.cz2 {
        // Swiper styles.
        @import 'swiper/scss';
        @import 'swiper/scss/navigation';
        @import 'swiper/scss/pagination';
        @import 'swiper/scss/scrollbar';

        .font-proxima {
            font-family: 'Proxima Nova', sans-serif;
        }

        position: relative;

        background: white;

        &.bg-darker-blue-gradient {
            // @include bg(gradientBlue);
        }

        box-sizing: border-box;

        width: 100%;
        height: 100%;

        &.cz2--scroll-overflow {
            overflow-y: auto !important;
        }

        * {
            box-sizing: border-box;
            touch-action: pan-x pan-y pinch-zoom;
        }

        opacity: 0;
        pointer-events: none;
        transition: opacity $transition-fast ease-out;

        [data-lock] {
            width: 100%;
            height: 100%;
        }

        &.cz2--loaded {
            opacity: 1;
            pointer-events: auto;
        }

        &.cz2--absolute {
            position: absolute;

            @include respond-above(sm) {
                position: absolute;
            }
        }

        &.cz2--no-outlines {
            *, a, button {
                outline: none !important;
            }

            :focus {
                outline: none !important;
            }
        }

        .cz2__global-busy {
            position: absolute;

            left: 0;
            top: 0;

            width: 100%;
            height: 100%;

            z-index: 10000;

            background: rgba(255, 255, 255, 0.6);

            cursor: wait;
        }

        .cz2__frame.cz2__frame--kiosk {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 1080px;
            height: 1920px;

            // overflow: clip;
        }

        .cz2__toty-logo {
            position: absolute;
            width: 80px;
            height: 80px;
        }

        @include respond-above(lg) {
            .cz2__toty-logo {
                width: 112px;
                height: 112px;
            }
        }

        @include respond-above(xl) {
            .cz2__toty-logo {
                width: 144px;
                height: 144px;
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__toty-logo {
            width: 144px;
            height: 144px;
        }
    }

    #cz2.cz2.cz2__is-kiosk.cz2__is-checkout-step {
        .cz2__toty-logo {
            z-index: 10;
        }
    }

    #cz2.cz2__is-sb {
        background: url('./assets/images/branded/sb-final/SB-Background-Pattern-1_M@2x.jpg') repeat center/cover;

        @include respond-above(lg) {
            background: url('./assets/images/branded/sb-final/SB-Background-Pattern-1_D@2x.jpg') repeat center/cover;
        }

        .cz2__steps {
            background: transparent;
        }
        .cz2__step-options-header, .cz2__steps-options__navigation {
            background: transparent;
            box-shadow: none;
        }
        .cz2__funko-logo-wrapper {
            display: none !important;
        }
    }

    #cz2.cz2__is-sb.cz2__is-kiosk {
        @include respond-above(lg) {
            background: url('./assets/images/branded/sb-final/SB-Background-Pattern-1_K@2x.jpg') repeat center/cover;
        }

        .cz2__blur-modal-close {
            z-index: 99999;
            top: 0;
            right: 0;
            position: absolute;
            margin-top: 16px;
            margin-right: 32px;
        }
    }

    #cz2.cz2.cz2__is-mariners {
        // background: radial-gradient(76.47% 28.44% at 50% 71.56%, #2C5235 0%, #213D28 100%);

        // &.bg-darker-blue-gradient {
        //     @include bg(gradientSM);
        // }
        &.cz2__is-checkout-step {
            // background: color(sdccBlue);
            // background-image: linear-gradient(180deg, #0A0A27 0%, #0A0A27 63.7%, rgba(13, 24, 62, 0) 100%),
            //     url(./assets/images/branded/sdcc-2026/sdcc-bg.jpg);
            // background-size: contain;
            // background-repeat: no-repeat;
            // background-position-y: bottom;

            background-image: url(./assets/images/branded/pokemon/pokemon-bg.jpg);
            background-size: contain;
            background-repeat: no-repeat;
            background-position-y: bottom;
        }

        .cz2__toty-logo {
            display: none;
        }
    }
</style>

<script>
    import Vue from 'vue';

    // eslint-disable-next-line
    import URL from 'url-polyfill';
    // eslint-disable-next-line
    import '@netless/canvas-polyfill';

    import FocusLock from 'vue-focus-lock';

    // Can't make replacement plugin to work with SassLoader... so we are going to use just a minimal vue module instead.

    // eslint-disable-next-line
    import AppTarget from './App-APP_TARGET.vue';

    import Customizer from './components/Customizer.vue';
    import TimeoutWarning from './components/TimeoutWarning.vue';
    import ServiceMenu from './components/ServiceMenu.vue';
    import PrintingProgress from './components/PrintingProgress.vue';
    import PrintingError from './components/PrintingError.vue';
    import SaveError from './components/SaveError.vue';
    import ChangeWarning from './components/ChangeWarning.vue';
    import OutOfStockWarning from './components/OutOfStockWarning.vue';
    import ProtectorUpsellModal from './components/ProtectorUpsellModal.vue';
    import DiscreetPackagingModal from './components/DiscreetPackagingModal.vue';
    import InspectModal from './components/InspectModal.vue';
    import AttachPackModal from './components/AttachPackModal.vue';
    import AttachPackInfoModal from './components/AttachPackInfoModal.vue';
    import PetPackInfoModal from './components/PetPackInfoModal.vue';
    import ProductInfoModal from './components/ProductInfoModal.vue';
    import SwitchPopModal from './components/SwitchPopModal.vue';
    import BaseModal from './components/ai/BaseModal.vue';
    import PreviewModal from './components/ai/PreviewModal.vue';
    import BlurModal from './components/ui/BlurModal.vue';
    import MainNavigationList from './components/MainNavigationList.vue';
    import RotateScreenMessage from './components/RotateScreenMessage.vue';
    import PaperStatus from './components/PaperStatus.vue';
    import KioskRestartButton from './components/KioskRestartButton.vue';
    import KioskRestartWarning from './components/KioskRestartWarning.vue';
    import FunkoSpinner from './components/ui/FunkoSpinner.vue';
    import ExitModal from './components/ExitModal.vue';
    import MouseLeaveModal from './components/MouseLeaveModal.vue';
    import SpecialBoxModal from './components/SpecialBoxModal.vue';
    import NamePopModal from './components/NamePopModal.vue';

    // Spelling Bee

    import SbInspectModal from './components/SbInspectModal.vue';
    import SbAttachPackModal from './components/SbAttachPackModal.vue';

    export default {
        props: {
            options: {
                type: Object,
                default: () => {},
            },
        },

        components: {
            AppTarget,
            FocusLock,
            KioskRestartButton,
            KioskRestartWarning,
            Customizer,
            TimeoutWarning,
            ServiceMenu,
            PrintingProgress,
            PrintingError,
            SaveError,
            ChangeWarning,
            OutOfStockWarning,
            ProtectorUpsellModal,
            DiscreetPackagingModal,
            InspectModal,
            AttachPackModal,
            AttachPackInfoModal,
            PetPackInfoModal,
            ProductInfoModal,
            SwitchPopModal,
            BaseModal,
            PreviewModal,
            BlurModal,
            MainNavigationList,
            RotateScreenMessage,
            PaperStatus,
            FunkoSpinner,
            ExitModal,
            MouseLeaveModal,

            SbInspectModal,
            SbAttachPackModal,
            SpecialBoxModal,
            NamePopModal,
        },

        data() {
            return {
                loaded: false,
                hideOutlines: true,
                sbSelectorModalShown: true,
                targetStyles: {},
            };
        },

        computed: {
            /**
             * Is the UX blocked?
             */
            globalBusy() {
                return this.$store.state.globalBusy;
            },

            /**
             * Shortcut to self-destruct flag.
             */
            selfDestruct() {
                return this.$store.state.selfDestruct;
            },

            /**
             * Current configuration.
             */
            configuration() {
                if (this.$store.state.customizer.options == null) {
                    return {};
                }

                return this.$store.state.customizer.options.configuration || {};
            },

            isEmea() {
                return this.$store.state.customizer.options.site === 'ecommerce,ecommerce-eu';
            },

            timeoutShown() {
                return this.$store.state.timeoutShown;
            },

            kioskRestartShown() {
                return this.$store.state.kioskRestartShown;
            },

            serviceMenuShown() {
                return this.$store.state.serviceMenuShown;
            },

            uiInteractions() {
                return this.$store.state.uiInteractions;
            },

            printingShown() {
                return this.$store.state.printingShown;
            },

            printingErrorShown() {
                return this.$store.state.printingErrorShown;
            },

            saveErrorShown() {
                return this.$store.state.saveErrorShown;
            },

            changeWarningShown() {
                return this.$store.state.changeWarningShown;
            },

            outOfStockWarningShown() {
                return this.$store.state.outOfStockWarningShown;
            },

            protectorUpsellShown() {
                return this.$store.state.protectorUpsellShown;
            },

            discreetPackagingModalShown() {
                return this.$store.state.discreetPackagingModalShown;
            },

            specialBoxModalShown() {
                return this.$store.state.specialBoxModalShown;
            },

            inspectModalShown() {
                return this.$store.state.inspectModalShown;
            },

            attachPackModalShown() {
                return this.$store.state.attachPackModalShown;
            },

            attachPackInfoModalShown() {
                return this.$store.state.attachPackInfoModalShown;
            },

            petPackInfoModalShown() {
                return this.$store.state.petPackInfoModalShown;
            },

            productInfoModalShown() {
                return this.$store.state.productInfoModalShown;
            },

            switchPopModalShown() {
                return this.$store.state.switchPopModalShown;
            },

            aiModalShown() {
                return this.$store.state.aiModalShown;
            },

            aiPreviewModalShown() {
                return this.$store.state.aiPreviewModalShown;
            },

            aiSpinnerShown() {
                return this.$store.state.aiSpinnerShown;
            },

            exitModalShown() {
                return this.$store.state.exitModalShown;
            },

            mouseLeaveModalShown() {
                return this.$store.state.mouseLeaveModalShown;
            },

            mouseLeaveModalWasShown() {
                return this.$store.state.mouseLeaveModalWasShown;
            },

            namePopModalShown() {
                return this.$store.state.namePopModalShown;
            },

            isNavMenuOpen() {
                return this.$store.state.customizer.isNavMenuOpen;
            },

            isKeyboardOpen() {
                return this.$store.state.customizer.isKeyboardOpen;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },

            isMobileDevice() {
                return /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            /**
             * Current step.
             */
            selectedStep() {
                return this.$store.state.selectedStep;
            },

            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            currentGroupCode() {
                return this.currentGroup?.code;
            },

            isCheckoutStep() {
                return this.currentGroupCode === 'Checkout';
            },

            isContactStep() {
                return this.currentGroupCode === 'Contact';
            },

            isConfirmStep() {
                return this.currentGroupCode === 'Confirm';
            },

            isNameStep() {
                return this.currentGroupCode === 'Name';
            },

            isReviewStep() {
                return this.currentGroupCode === 'Review';
            },

            showDarkerBackground() {
                return this.isCheckoutStep || this.isNameStep || this.isReviewStep;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            isMariners() {
                return this.$store.state.isMariners;
            },

            screensaverShown() {
                return this.$store.state.screensaverShown;
            },

            isStarted() {
                return this.$store.getters.isStarted;
            },

            isSplashPage() {
                return this.$store.state.selectedStep === 'splash' || this.$store.state.selectedStep === 'splashSelector';
            },
        },

        watch: {
            /**
             * Begin self-destruct sequence.
             */
            selfDestruct(v) {
                if (v) {
                    this.loaded = false;

                    setTimeout(() => {
                        this.$emit('selfDestruct');
                    }, 500);
                }
            },

            uiInteractions() {
                this.beginTimeout();
            },

            currentGroup() {
                this.$store.dispatch('setIsSubMenuOpen', false);
            },

            isKeyboardOpen() {
                if (this.isMobile && !this.isKeyboardOpen) {
                    this.resize();
                }
            },
        },

        mounted() {
            this.hideSiteElements();

            this.checkIfMobileApp();

            this.saveOptions();

            this.listenForErrors();

            this.listenForUpdates();

            this.loaded = true;

            this.listenToOnlineStatus();

            // Hide everything so we have a clean page.
            document.body.classList.add('cz2__overlay-lock');

            this.beginTimeout();

            // Kick off the printer check.
            this.printerTimer = setInterval(this.checkPrinter, 15000);

            this.$nextTick(() => {
                this.checkPrinter();
            });

            // this.$nextTick(() => {
            //     this.$store.dispatch('scrollToApp');
            // });

            window.addEventListener('resize', this.resize);

            // Because the scrolling state may have changed now with the body height adjusted, reevaluate sizing a moment later.
            this.heightTimer = setInterval(this.resize, 100);

            this.$nextTick(() => {
                this.resize();
            });

            // Push an initial state into the history stack (part of preventing browser navigation)
            window.history.pushState(null, document.title, window.location.href);

            window.addEventListener('popstate', this.showMouseLeaveModal);
            document.addEventListener('mouseleave', this.showMouseLeaveModal);
        },

        beforeDestroy() {
            document.body.classList.remove('cz2__overlay-lock');

            window.removeEventListener('resize', this.resize);

            window.removeEventListener('popstate', this.showMouseLeaveModal);
            document.removeEventListener('mouseleave', this.showMouseLeaveModal);

            if (this.isKiosk) {
                window.removeEventListener('online', this.setOnlineStatus);
                window.removeEventListener('offline', this.setOnlineStatus);
            }

            if (this.printerTimer) {
                clearInterval(this.printerTimer);
            }
        },

        methods: {
            checkIfMobileApp() {
                const isMobileApp = window.location.search.includes('popyourself-target=app');

                this.$store.dispatch('setIsMobileApp', isMobileApp);
            },

            hideSiteElements() {
                if (this.options.isKiosk) {
                    // Hide site header and footer.
                    const siteHeader = document.getElementById('site-header');
                    const siteFooter = document.getElementById('footercontent');
                    const wrapper = document.querySelector('#cz2.cz2');
                    const page = document.getElementsByClassName('page');

                    if (page.length) {
                        page[0].style.marginTop = 0;
                    }

                    wrapper?.style.setProperty('overflow', 'hidden');
                    siteHeader?.style.setProperty('display', 'none');
                    siteFooter?.style.setProperty('display', 'none');
                }
            },

            /**
             * Save options in all modules.
             */
            saveOptions() {
                this.$store.dispatch('setOptions', this.options);
                this.$store.dispatch('setCustomizerOptions', this.options);
                this.$store.dispatch('setEcommerceOptions', this.options);

                this.$store.dispatch('setTranslations', (key) => this.$t(key));
                this.$store.dispatch('setTranslationsRaw', this.$i18n);

                this.$store.dispatch('log', {
                    level: 'info',
                    message: `App mounted for ${this.options.site}`,
                });
            },

            listenForErrors() {
                // Listen to global javascript errors.
                window.onerror = (message, source, lineno, colno, error) => {
                    this.$store.dispatch('log', {
                        level: 'error',
                        message: `Unhandled JavaScript error: ${message} in ${source} at ${lineno}:${colno}: ${(error || '').toString()}`,
                    });
                };

                // Also listen for Vue errors.
                Vue.config.errorHandler = (err, vm, info) => {
                    this.$store.dispatch('log', {
                        level: 'error',
                        message: `Unhandled Vue error: ${(err || '').toString()} in ${(vm || '').toString()}: ${(info || '').toString()}`,
                    });

                    if (err && err.stack) {
                        this.$store.dispatch('log', {
                            level: 'error',
                            message: `Stack: ${err.stack.toString()}`,
                        });
                    }

                    if (console.error) {
                        console.error(`Unhandled Vue error (${info}):`, err);
                    }
                };
            },

            listenForUpdates() {
                // Listen for global background app updates.
                window.onUpdateState = (state) => {
                    this.$store.dispatch('setBackgroundState', state);
                };

                // Push tickets to the app.
                window.onUpdateTickets = (tickets) => {
                    this.$store.dispatch('setSavedTickets', tickets);
                };
            },

            listenToOnlineStatus() {
                // Add listener for online status, call to get initial online status
                if (this.isKiosk) {
                    window.addEventListener('online', this.setOnlineStatus);
                    window.addEventListener('offline', this.setOnlineStatus);
                    this.setOnlineStatus();
                }
            },

            setOnlineStatus() {
                this.$store.dispatch('setIsOnline', navigator.onLine);
                if (!navigator.onLine && this.selectedStep !== 'splash') {
                    this.$store.dispatch('resetCustomizations');
                    this.$store.dispatch('selectStep', 'splash');
                }
                this.$store.dispatch('setIsOnline', navigator.onLine);
            },

            /**
             * Hides outlines on mouse actions.
             */
            mouseDown() {
                this.hideOutlines = true;
                this.beginTimeout();
            },

            /**
             * Shows outlines again when keyboard is engaged.
             */
            keyDown() {
                this.hideOutlines = false;
                this.beginTimeout();
            },

            /**
             * Resizes the containers.
             */
            resize() {
                const width = window.innerWidth;
                const height = window.innerHeight;

                this.$store.dispatch('setWindowWidth', width);
                this.$store.dispatch('setWindowHeight', height);

                if (!this.$refs?.app?.classList?.length) {
                    return;
                }

                const frameHeight = window.innerHeight;
                // const isWebSplashPage = this.isSplashPage && !this.isKiosk;
                const hasScrolling = false;
                const appHeight = hasScrolling ? this.$refs.app.scrollHeight : 0;

                const h = Math.max(frameHeight, appHeight);

                if (this.lastHeight !== h && !this.isCheckoutStep && !this.isNameStep) {
                    this.$refs.app.style.setProperty('--frame-height', `${frameHeight}px`);

                    this.lastHeight = h;

                    const appParent = this.$refs.app.parentElement;

                    if (appParent) {
                        appParent.style.height = `${h}px`;
                        appParent.style.minHeight = `${h}px`;
                    }

                    this.resizeFrame();
                }

                this.checkIfMobile();
            },

            /**
             * Calculate the frame size so the app is testable in Electron on desktop devices.
             *
             * Bringing it back since using the inspector device emulation in Electron build is hard for users.
             */
            resizeFrame() {
                if (!this.isKiosk) {
                    return;
                }

                const appWidth = this.$refs.app.offsetWidth;
                const appHeight = this.$refs.app.offsetHeight;

                const frameWidth = 1080;
                const frameHeight = 1920;

                let scale = 1;

                if (frameWidth > appWidth) {
                    scale = appWidth / frameWidth;
                }

                const frameScaled = scale * frameHeight;

                if (frameScaled > appHeight) {
                    scale = (scale * appHeight) / frameScaled;
                }

                if (this.lockScale == null || this.lockScale !== scale) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: `Adjust lock scale to ${scale}`,
                    });

                    this.lockScale = scale;

                    this.$refs.frame.style.transform = `translate(-50%, -50%) scale(${scale}, ${scale})`;

                    this.$refs.frame.style.setProperty('--vw100', `${frameWidth}px`);
                    this.$refs.frame.style.setProperty('--vh100', `${frameHeight}px`);
                }
            },

            /**
             * See if the screen is below the lg breakpoint.
             */
            checkIfMobile() {
                this.$store.dispatch('setIsMobile', window.innerWidth < 1024);
            },

            /**
             * Restart idle timeout.
             */
            beginTimeout() {
                if (this.timeoutTimer) {
                    clearTimeout(this.timeoutTimer);
                    this.timeoutTimer = null;
                }

                if (this.configuration && this.configuration.idleTimeout) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: `Idle timeout started, will expire in ${this.configuration.idleTimeout}ms`,
                    });

                    this.timeoutTimer = setTimeout(() => {
                        this.timeoutExpired();
                    }, this.configuration.idleTimeout);
                }
            },

            timeoutExpired() {
                this.$store.dispatch('log', {
                    level: 'info',
                    message: 'Idle timeout expired',
                });

                if (this.$store.state.customizer.options != null && !this.isKiosk) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: '... but we are not on a kiosk, skipping',
                    });

                    // Reset the timer.
                    this.$store.dispatch('uiInteracted');

                    return;
                }

                // Timeout expired while the printing popup is shown.
                if (this.printingShown) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: '... timeout expired while printing, skipping',
                    });

                    // Reset the timer.
                    this.$store.dispatch('uiInteracted');

                    return;
                }

                // Timeout expired again while the popup is shown.
                if (this.timeoutShown) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: '... timeout popup is already active, skipping',
                    });
                    return;
                }

                // Timeout expired while on splash page.
                if (this.selectedStep === 'splash') {
                    // Show the screensaver again
                    if (!this.screensaverShown) {
                        this.$store.dispatch('setScreensaverShown', true);
                    } else {
                        this.$store.dispatch('log', {
                            level: 'info',
                            message: '... while splash page is already shown, skipping',
                        });
                    }

                    return;
                }

                this.$store.dispatch('showTimeoutWarning', true);
            },

            checkPrinter() {
                this.$store.dispatch('checkPrinterStatus');
            },

            closeNavMenu() {
                this.$store.dispatch('setIsNavMenuOpen', false);
            },

            onScroll() {
                if (this.isCheckoutStep) {
                    return;
                }

                // Force no-scroll manually, since overflow: clip is causing issues.
                if (this.$refs.app) {
                    if (this.$refs.app.scrollTop !== 0) {
                        this.$refs.app.scrollTop = 0;
                    }
                }
            },

            setStyles(v) {
                this.targetStyles = v;
            },

            showMouseLeaveModal(event) {
                if (this.isStarted && !this.isKiosk && !this.mouseLeaveModalWasShown) {
                    if (event.type === 'popstate') {
                        // Push the current URL back into the stack, "trapping" user on the current page
                        window.history.pushState(null, document.title, window.location.href);
                    }

                    this.$store.dispatch('showMouseLeaveModal', true);
                    this.$store.dispatch('setMouseLeaveModalWasShown', true);
                }
            },
        },
    };
</script>
